module.exports = __webpack_public_path__ + "img/lounge_hover_152c405.webp";